/** Shared visual tokens for the public landing page. */
export const landingTheme = {
  bg: '#050a14',
  bgAlt: '#0a1120',
  text: '#f0f4ff',
  textSecondary: '#9aa8c7',
  textMuted: '#6b7a99',
  accent: '#5c6cff',
  accentBright: '#7b89ff',
  cyan: '#00bcd4',
  violet: '#9d7bff',
  glass: 'rgba(255, 255, 255, 0.04)',
  glassBorder: 'rgba(255, 255, 255, 0.08)',
  glassHover: 'rgba(255, 255, 255, 0.07)',
  gradientHero: 'linear-gradient(135deg, #f0f4ff 0%, #b8c4ff 45%, #00bcd4 100%)',
  gradientCta: 'linear-gradient(120deg, rgba(92,108,255,0.35) 0%, rgba(0,188,212,0.22) 50%, rgba(157,123,255,0.28) 100%)',
  shadowGlow: '0 0 80px rgba(92, 108, 255, 0.18)',
  shadowCard: '0 24px 48px rgba(0, 0, 0, 0.35)',
};

export const glassCardSx = {
  background: 'rgba(12, 20, 38, 0.72)',
  backdropFilter: 'blur(16px)',
  WebkitBackdropFilter: 'blur(16px)',
  border: `1px solid ${landingTheme.glassBorder}`,
  borderRadius: 3,
  boxShadow: landingTheme.shadowCard,
};

export const outlinedBtnSx = {
  color: landingTheme.text,
  borderColor: 'rgba(255, 255, 255, 0.18)',
  backdropFilter: 'blur(8px)',
  '&:hover': {
    borderColor: 'rgba(255, 255, 255, 0.35)',
    backgroundColor: landingTheme.glassHover,
  },
};

export const primaryBtnSx = {
  fontWeight: 700,
  background: `linear-gradient(135deg, ${landingTheme.accent} 0%, #4455ee 100%)`,
  boxShadow: '0 8px 24px rgba(92, 108, 255, 0.35)',
  '&:hover': {
    background: `linear-gradient(135deg, ${landingTheme.accentBright} 0%, ${landingTheme.accent} 100%)`,
    boxShadow: '0 12px 32px rgba(92, 108, 255, 0.45)',
  },
};
